module.exports = __webpack_public_path__ + "img/logo.c273db56.png";